import { useEffect, useRef } from 'react';
import { useLocation, useMatches } from 'react-router';

import { useUserBi } from '../../hooks/useUserBi/useUserBi.js';
import {
  getRouteTelemetryKey,
  resolveRouteTelemetry,
} from '../../routeTelemetry.js';
import { PanelRegion } from '../../userbi.js';

export function RouteTelemetryTracker() {
  const { pathname, search } = useLocation();
  const matches = useMatches();
  const { recordView } = useUserBi();
  const lastKey = useRef<string | null>(null);

  useEffect(() => {
    const route = resolveRouteTelemetry(matches, { pathname, search });
    if (route === null) {
      lastKey.current = null;
      return;
    }

    const key = getRouteTelemetryKey(route);
    if (lastKey.current === key) return;
    lastKey.current = key;
    recordView({
      panelType: route.panelType,
      panelRegion: PanelRegion.Main,
      eventID: `${route.panelType}_${route.view}`,
      data: {
        'Usage.View': route.view,
        ...route.data,
      },
    });
  }, [matches, pathname, recordView, search]);

  return null;
}
